<template>
  <info-dialog
    v-model="modelValue"
    title="Equivalência das doses de corticoides inalatórios licenciados para uso no Brasil."
  >
    <p class="font-size-14">
      *Atenção! Segundo as "Recomendações para o Manejo da Asma Grave da Sociedade Brasileira de Pneumologia e
      Tisiologia - 2021", asma grave é definida, entre outros fatores, como o paciente que necessita utilizar corticoide
      inalatório em dose alta continuamente, caracterizada como budesonida ≥ 1600 mcg ou equivalente. O PCDT considera
      também, dentre outros fatores, a dose alta como sendo budesonida ≥ 1600 mcg ou equivalente, para definição de asma
      grave, e então prescrição dos imunobiológicos incorporados.
    </p>
    <p class="font-size-12">
      Ref.: 1. Pizzichini, M. M. M. et al. 2020 Brazilian Thoracic Association recommendations for the management of
      asthma. J. bras. pneumol. 46, e20190307 (2020).
    </p>
    <img src="assets/attendance-form/corticosteroid-table.png" alt="" />
  </info-dialog>
</template>

<script>
import { ComputedOptions } from 'vue'
import InfoDialog from '@/components/NewAttendanceForm/FormNodes/InfoDialogs/InfoDialog.vue'

export default {
  name: 'InhaledCorticosteroidDialog',
  components: { InfoDialog },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
